import React, {useState} from 'react'
import {Helmet} from 'react-helmet';
import {Input, Tooltip} from 'aurorui';
import './style.css';
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';

function InputScreen() {
    const [value, setValue] = useState('');

  return (
    <div className=' screen red-bg'>
      <Helmet>
          <meta charSet="utf-8" />
          <title>Input</title>
      </Helmet>
      <h1 className="component-name">Input</h1>
    
      <div className='display-wrapper'>
            <div className='display_grid_input'>
            <div className='buttonDiv'>
                <Input 
                    value={value}
                    label="input"
                    variant='outlined'
                    error=""
                    backgroundColor='transparent'
                    textColor='white'
                />
            </div>
             <div className='buttonDiv'>
                <Input 
                    value={value}
                    label="input"
                    variant='bottom-outlined'
                    error=""
                    backgroundColor='#ff3232'
                    textColor='white'
                    borderColor='white'
                />
            </div>
            <div className='buttonDiv'>
                <Input 
                    value={value}
                    label="input"
                    variant='outlined'
                    error="here error get displyed"
                    backgroundColor='#ff3232'
                    textColor='white'
                    borderColor='white'
                />
            </div>

            </div>
      </div>
     

      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props}/>
      </div>
    </div>
  );
}


const props = [
  {
    name: "label",
    required: 'true',
    description: "the label for input",
    possible_values: "string"
  },
  {
    name: "value",
    required: 'true',
    description: "The input value of the input",
    possible_values: "string"
  },
  {
    name: "backgroundColor",
    required: 'true',
    description: "background color of the button",
    possible_values: "any hex or rgb value"
  },
  {
    name: "variant",
    required: 'true',
    description: " cchoose the variant of the buutton",
    possible_values: " 'bottom-outlined' 'outlined' "
  },
  {
    name: "error",
    required: 'false',
    description: " validation error concerned to the input",
    possible_values: " string "
  },
  {
    name: "borderColor",
    required: 'false',
    description: " borderColor of the input",
    possible_values: " rgb, rgba, hex values"
  },
  {
    name: "textColor",
    required: 'true',
    description: " text color of input",
    possible_values: " rgb, rgba, hex values"
  },
]
export default ComponentScreen(InputScreen);

